module.exports = "/assets/data/0600ab1263f5d765395cf50657a9a110-CR5.data.json";